export enum FileExtensions {
  PNG = 'png',
  SVG = 'svg',
}
